import { render, staticRenderFns } from "./MessageBlocks.vue?vue&type=template&id=fd4355ee&scoped=true"
import script from "./MessageBlocks.vue?vue&type=script&lang=js"
export * from "./MessageBlocks.vue?vue&type=script&lang=js"
import style0 from "./MessageBlocks.vue?vue&type=style&index=0&id=fd4355ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4355ee",
  null
  
)

export default component.exports